import { type GitFeatureFlags } from './types'
import { useFlags } from '@matillion/hub-client'

const useFeatureFlags = () => useFlags<GitFeatureFlags>()

export default useFeatureFlags
